import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../services/auth.service';

 

@Pipe({
  name: 'addtoken'
})
export class AddTokenPipe implements PipeTransform {

 

  token: string;

 

  constructor(private authService: AuthService) {    
  }

 

  async transform(value: string): Promise<any> {
    try {
      const res = await this.authService.getAccessToken().toPromise();
      this.token = res;
      return value + '?access_token=' + this.token;
    } catch (error) {
      // Manejo de errores si ocurre algún problema con el Observable convertido en Promesa
      console.error(error);
      // Puedes lanzar una excepción aquí o devolver un valor predeterminado en caso de error.
    }
  }
  

 

}